// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowDown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-down': IconArrowDown;
    }
}

/**
 * The icon component for the 'arrowDown' icon
 */
export class IconArrowDown extends IconSvg {
    public constructor() {
        super(arrowDown16X16);
    }
}

registerIconSvg('icon-arrow-down', IconArrowDown);
export const iconArrowDownTag = 'nimble-icon-arrow-down';
